<!--客户案例-->
<template>
  <div>
    <!--政府案例导航图-->
    <el-row v-show="government_visible">
      <el-col :span="24">
        <div class='animate__animated animate__zoomIn animate__slow'>
         <el-carousel class='carousel_class'>
          <el-carousel-item v-for='item in carouselList' :key='item.id'>
            <div class='block' @click='jump(item)'>
              <el-image class='image-slot'
                        :fit='fit'
                        v-if='item.imageUrl != null'
                        :src='item.imageUrl'
              />
              <h3>{{ item.name }}</h3>
            </div>
          </el-carousel-item>
        </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--企业顾问导航图-->
    <el-row v-show="enterprise_visible">
      <el-col :span="24">
        <div class='animate__animated animate__zoomIn animate__slow'>
          <el-carousel class='carousel_class'>
            <el-carousel-item v-for='item in enterpriseList' :key='item.id'>
              <div class='block' @click='jump(item)'>
                <el-image class='image-slot'
                          :fit='fit'
                          v-if='item.imageUrl != null'
                          :src='item.imageUrl'
                />
                <h3>{{ item.name }}</h3>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
    </el-row>
    <!--tabs标签页-->
    <el-row>
      <el-col :span="4"><div class="grid-content"></div></el-col>
      <el-col :span="16">
        <div class='animate__animated animate__zoomIn animate__slow'>
          <div class="grid-content">
          <el-tabs v-model="activeName" @tab-click="handleClick">

            <el-tab-pane name="first">
              <template slot="label">
                <div class="know_item">
                  <p> 政府案例</p>
                  <span>GOVERNMENT CASES</span>
                </div>
              </template>
              <el-row>
                <el-col :span="4"><div class="grid_content"></div></el-col>
                <el-col :span="16">
                  <div class='animate__animated animate__fadeInUp animate__slower'>
                    <div class="grid_content">
                    <ul class='governmentCase'>
                      <li class="homeImageList" v-for='item in homeGovernmentListData' :key='item.id'>
                        <vue-hover-mask class='imgs' @click='customerType(item)' style='height: 240px;width: 100%'>
                          <div class='pic_item_1' @click='customerType(item)'>
                            <el-image class='smallNew'
                                      :src='item.homeImageUrl'
                            />
                          </div>
                          <template v-slot:action>
                            <i class='iconfont icon-bianji-copy'>{{ item.profile }}</i>
                          </template>
                        </vue-hover-mask>
                      </li>
                    </ul>
                  </div>
                  </div>
                </el-col>
                <el-col :span="4"><div class="grid_content"></div></el-col>
              </el-row>
            </el-tab-pane>

            <!--企业顾问-->
            <el-tab-pane  name="second">
              <template slot="label">
                <div class="know_item">
                  <p> 企业案例</p>
                  <span>BUSINESS CASES</span>
                </div>
              </template>
              <div class='animate__animated animate__fadeInUp animate__slower'>
                <div class="grid_content">
                <ul class='enterpriseCase'>
                  <li class="homeImageList" v-for='item in homeEnterpriseListData' :key='item.id'>
                    <vue-hover-mask class='imgs' @click='customerType(item)' style='height: 240px;width: 100%'>
                      <div class='pic_item_1' @click='customerType(item)'>
                        <el-image class='smallNew'
                                  :src='item.homeImageUrl'
                        />
                      </div>
                      <template v-slot:action>
                        <i class='iconfont icon-bianji-copy'>{{ item.profile }}</i>
                      </template>
                    </vue-hover-mask>
                  </li>
                </ul>
              </div>
              </div>
            </el-tab-pane>

          </el-tabs>
        </div>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VueHoverMask from 'vue-hover-mask'
import { homeEnterpriseCaseList, homeGovernmentCaseList, selectCarouselPicture } from '../../api/auth'

export default {
  created () {
    this.homeGovernmentCaseList()
    this.homeEnterpriseCaseList()
    this.selectCarouselPicture()
    this.selectEnterprisePicture()
  },
  activated () {
    if (localStorage.getItem('customerStories') === '') {
      this.activeName = 'first'
      this.government_visible = true
      this.enterprise_visible = false
    } else {
      this.activeName = localStorage.getItem('customerStories')
      if (this.activeName === 'first') {
        this.government_visible = true
        this.enterprise_visible = false
      } else if (this.activeName === 'second') {
        this.government_visible = false
        this.enterprise_visible = true
      } else {
        this.activeName = 'first'
        this.government_visible = true
        this.enterprise_visible = false
      }
    }
  },
  data () {
    return {
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      carouselList: [],
      government_visible: true,
      enterprise_visible: false,
      carouselParams: {
        type: 5
      },
      enterpriseParams: {
        type: 6
      },
      enterpriseList: [],
      homeGovernmentListData: [],
      homeEnterpriseListData: [],
      queryParams: {},
      activeName: 'first',
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
    }
  },
  components: {
    VueHoverMask
  },
  methods: {
    jump (raw) {
    },
    /** 滚动图  */
    selectEnterprisePicture () {
      let that = this
      selectCarouselPicture(this.enterpriseParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.enterpriseList = res
      })
    },
    /** 滚动图  */
    selectCarouselPicture () {
      let that = this
      selectCarouselPicture(this.carouselParams).then(res => {
        res.forEach((value, index) => {
          value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.carouselList = res
      })
    },
    /** 政府案例查询 */
    homeGovernmentCaseList () {
      let that = this
      homeGovernmentCaseList(this.queryParams).then(res => {
        res.forEach((value, index) => {
          value.homeImageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.homeGovernmentListData = res
      })
    },

    /** 企业案例查询 */
    // eslint-disable-next-line vue/no-dupe-keys
    homeEnterpriseCaseList () {
      let that = this
      homeEnterpriseCaseList(that.queryParams).then(res => {
        res.forEach((value, index) => {
          value.homeImageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
        })
        that.homeEnterpriseListData = res
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.government_visible = true
        this.enterprise_visible = false
      } else {
        this.government_visible = false
        this.enterprise_visible = true
      }
    },
    customerType (raw) {
      this.$router.push({
        path: '/textContent',
        query: {
          id: raw.id,
          type: 1
        }
      })
    }
  }
}
</script>

<style>
.homeImageList .vue-hover-mask_action,.homeImageList img {

  transition: 0.5s ease-in-out;
}
.homeImageList:hover .vue-hover-mask_action {
  transform: scale(1.1);
}
.homeImageList:hover img {
  transform: scale(1.1);
}
</style>

<style lang="less" scoped>
.block{
  .image-slot{
    width: 100%;
    height: 300px;
    margin-bottom: 40px;
  }
}
.grid-content {
  min-height: 50px;
  //tobs标题
  .know_item{
    font-weight: normal;
    p{
      font-size: 28px;
      line-height: 20px;
      padding-top: 18px;
    }
    span{
      display: block;
      height: 30px;
    }
  }
  .governmentCase{
    display: block;
    min-height: 530px;
    margin-top:30px;
    width: 150%;
    li {
      display: block;
      float: left;
      width:33.33%;
      height: 240px;
      padding:0 10px;
      margin-bottom: 18px;

      .smallNew {
        width:100%;
        height:100%;
      }

      i {
        display: block;
        width: 90%;
        font-size: 16px;
        font-style: normal;
        font-family: "MicrosoftYaHei";
        text-align: center;
        line-height: 25px;
        padding: 15px;
        text-shadow: 2px 2px 6px #000;
        margin: 90px auto 0;
      }
    }
  }
  .enterpriseCase{
    display: block;
    margin-top:30px;
    width: 100%;
    min-height: 530px;
    li {
      display: block;
      float: left;
      width:33.33%;
      height: 240px;
      padding:0 10px;
      margin-bottom: 18px;

      .smallNew {
        width:100%;
        height:100%;
      }

      i {
        display: block;
        width: 90%;
        font-size: 16px;
        font-style: normal;
        font-family: "MicrosoftYaHei";
        text-align: center;
        line-height: 25px;
        padding: 15px;
        text-shadow: 2px 2px 6px #000;
        margin: 90px auto 0;
      }
    }
  }
}
//Tabs标签页
::v-deep .el-tabs{
  display: block;
  //width:500px;
  margin: 0 auto;
}
//Tabs居中
::v-deep .el-tabs__nav {
  margin-left:380px;
}
::v-deep .el-tabs__item {
  padding: 0;
  width: 250px;
  height: 80px;
  font-family: "MicrosoftYaHei";
  text-align: center;
  position: relative;
}
//tabs下划线
::v-deep .el-tabs__active-bar{
  background-color: #11a84e;
}
//tabs鼠标移入事件
::v-deep .el-tabs__item:hover{
  color: #11a84e;
}
//tabs鼠标点击事件
::v-deep .el-tabs__item.is-active {
  color: #fff !important;
  background-color:#11a84e ;
}
//tabs上边距
::v-deep .el-tabs__nav-scroll .el-tabs__item {
  margin-top: 50px;
}
.pic_item_1 {
  position: relative;
  height: 100%;
}

.pic_item_1:hover {
  cursor: pointer;
}
.pic_item_1 h3 {
  position: absolute;
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  height: 40px;
  line-height: 25px;
  width: 380px;
  padding-top: 7px;
  border-radius: 50px;
  background-color: #11a84e;
  bottom: 0px;
}

.smallNew {
  width: 450px;
  height: 100%;
  position: relative;

}
.carousel_class {
  //height: 260px;
  margin: 0;
  padding: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.smallNew:hover {
  width: 100%;
  height: 100%;
  transform: scale(1.1); //图片按照比例，整体放大了1.2倍
  // 当鼠标经过是图片放大的倍数为1.2倍
}
::v-deep .vue-hover-mask_action {
  background: linear-gradient(-90deg, rgba(5, 201, 127, 0.6), rgba(6, 172, 250, 0.7));
  border-radius: 10px;
}
</style>
